import { render, staticRenderFns } from "./CertificatesCompanyTab.vue?vue&type=template&id=24997591"
import script from "./CertificatesCompanyTab.vue?vue&type=script&lang=js"
export * from "./CertificatesCompanyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports